export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'
export const DEFAULT_RANGE_FORMAT = 'YYYY-MM-DD - YYYY-MM-DD'
